<template>
  <div class="">
    <transition name="modal">
      <div class="">
        <div class="">
          <br />
          <br />

          <div class="modal-container">
            <!-- <div class="text-right">
              <h4 class=" text-right text-danger" @click="$emit('close')">
                Close
              </h4>
            </div> -->
            <div class="modal-body">
              <div>
                <div class="headingg">
                  <h2 class="login-title" v-show="activeIndex == 0">
                    Product Information
                  </h2>
                  <div v-show="activeIndex == 1 && !sucessMsg">
                    <h2 class="login-title">
                      Job/Business Information
                    </h2>
                  </div>

                  <div v-show="activeIndex == 0" class="main-body">
                    <h2>{{ titleProduct }}</h2>
                    <p>{{ desc }}</p>
                    <div>
                      <calculator
                        v-if="amt"
                        :productName="titleProduct"
                        :typeProduct="amt"
                        @nextFunc="nextFunc"
                        @toKyc="$emit('goToKyc')"
                      ></calculator>
                      <br />
                      <hr />
                      <div
                        v-if="form.tenure"
                        class="info-footer"
                        style="width: 100%;"
                      >
                        <div class="info-below">
                          <div class="font-weight-bold">
                            First Payment Before Installation
                          </div>

                          <div class="amt">
                            N{{
                              (amountToPay.caution + "").replace(
                                /(\d)(?=(\d{3})+(?!\d))/g,
                                "$1,"
                              )
                            }}
                            <br />
                          </div>
                        </div>
                        <hr />
                        <div class="info-below">
                          <div class="font-weight-bold">
                            Recurring Monthly Payment
                          </div>

                          <div class="amt">
                            N{{
                              (amountToPay.monthly + "").replace(
                                /(\d)(?=(\d{3})+(?!\d))/g,
                                "$1,"
                              )
                            }}
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="activeIndex == 1" class="main-body">
                    <p
                      v-show="sucessMsg"
                      class="font-weight-bold text-success success-message"
                    >
                      {{ message }}
                    </p>
                    <p v-show="errMsg" class="font-weight-bold text-danger">
                      All fields are required!
                    </p>
                    <p
                      v-show="errorMessage"
                      class="font-weight-bold text-danger"
                    >
                      {{ message }}
                    </p>
                    <br />
                    <div v-show="!sucessMsg">
                      <arnergy-select
                        v-model="form.employment"
                        label="What's your employment status ?"
                        :items="employmentStatus"
                      />

                      <arnergy-select
                        v-model="form.income"
                        label="What's your monthly income ?"
                        :items="incomes"
                      />

                      <div>
                        <div v-show="form.employment == 'Self Employed'">
                          <arnergy-select
                            v-model="form.business"
                            label="What's your business type ?"
                            :items="BT"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- form elements -->
                  <div v-show="activeIndex == 1">
                    <div>
                      <!-- <div v-if="modalstate" className="text-center">
                        <div class="submit-gif">
                          <div
                            class="spinner-border"
                            style="width: 3rem; height: 3rem;"
                            role="status"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      </div>  v-else -->
                      <div>
                        <div v-if="loader" className="text-center">
                          <div class="submit-gif">
                            <div
                              class="spinner-border"
                              style="width: 3rem; height: 3rem;"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <button
                            v-show="ctn == false"
                            @click="finalReq"
                            class="submit-button"
                            type="button"
                          >
                            Continue &rarr;
                          </button>
                          <button
                            v-show="ctn"
                            @click="$emit('proceed')"
                            class="submit-button"
                            type="button"
                          >
                            Continue &rarr;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";
import { mapGetters, mapActions } from "vuex";
import ArnergySelect from "../AnergySelectDynamic.vue";
import Agreement from "./Agreement";
import Calculator from "./Calculator";
import Cookie from "js-cookie";
import axios from "axios";
export default {
  name: "Modal",
  props: {
    productDetails: []
  },
  components: {
    ArnergyInput,
    ArnergySelect,
    Agreement,
    Calculator
  },
  computed: {
    ...mapGetters(["getCustomerProductOptions"])
  },
  data() {
    return {
      productDetails: null,
      titleProduct: null,
      amt: null,
      desc: null,
      costShow: false,
      ctn: false,
      product: {},
      message: "",
      price: Cookie.get("amtPay") ? Cookie.get("amtPay") : "",
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [
        { id: "Oil & Gas", name: "Oil & Gas" },
        { id: "Farmer", name: "Farmer" },
        { id: "Driver", name: "Driver" },
        { id: "Painter", name: "Painter" }
      ],
      cacAmt: "",
      employmentStatus: [
        { id: "Employed", name: "Employed" },
      ],
      incomes: [
        { id: "1", name: " Below N500,000" },
        { id: "2", name: "Between N500,000 and N750,000" },
        {
          id: "3",
          name: "Between N750,000 and N1,000,000"
        },
        { id: "4", name: "Above N1,000,000" }
      ],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      errMsg: false,
      form: {
        tenure: "",
        income: "",
        employment: "",
        business: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    async fetchAll() {
      // parse for "arnergy-select" use
      this.products = this.productDetails;
    },
    getAmtofTenure(id) {
      let obj = this.tenures.find(x => x.id == id);
      this.amountToPay = obj;
      console.log(obj);
      localStorage.productID = obj.productID;
    },
    finalReq() {
      const HTTP = this.$httpUtils.instance;
      // const data = {
      //   customerId: localStorage.customerId,
      //   productid: 1,
      //   tenure: localStorage.proTenure,
      //   firstPaymentAmt: localStorage.amtPay,
      //   recurrentMonthlyAmt: localStorage.amtRepay,
      //   employmentStatus: this.form.employment,
      //   monthlyIncomeRange: this.form.income,
      //   typeOfBusiness: this.form.business,
      // }
      let incomeRange;
      this.incomes.map(income => {
        if (income.id === this.form.income) {
          incomeRange = income.id;
        }
      });
      const data = {
        customerId: localStorage.customerId,
        productid: localStorage.productId,
        tenure: localStorage.proTenure,
        firstPaymentAmt: localStorage.amtPay,
        recurrentMonthlyAmt: localStorage.amtRepay,
        employmentStatus: this.form.employment,
        monthlyIncomeRange: incomeRange,
        typeOfBusiness: this.form.business,
        totalPayment: localStorage.totalPayment,
        cautionFee: localStorage.cautionFee,
        setupFee: localStorage.setupFee,
        upfrontPayment: localStorage.upfrontPayment
      };
      // console.log(data)

      if (data.employmentStatus && data.monthlyIncomeRange) {
        this.loader = true;
        HTTP.post(`/CustomerProductOptions/saveCustomerOption`, data)
          .then(res => {
            // console.log(res.data);
            if (res.data.status) {
              localStorage.optionID = res.data.optionId;
              localStorage.amtPayID = res.data.optionId;

              this.loader = false;
              this.message = res.data.message;
              this.errorMessage = false;
              this.sucessMsg = true;
              this.ctn = true;

              localStorage.removeItem("amtPay");
              localStorage.removeItem("amtRepay");
              localStorage.removeItem("proTenure");
              localStorage.removeItem("cautionFee");
              localStorage.removeItem("setupFee");
              localStorage.removeItem("upfrontPayment");
              localStorage.removeItem("totalPayment");
              localStorage.removeItem("productId");
            } else {
              this.message = res.data.message;
              this.errorMessage = true;
              this.loader = false;
              this.sucessMsg = false;
              // setTimeout(() => {
              // window.location.href = '/onboarding'
              // },2000)
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.errMsg = true;
        setTimeout(() => (this.errMsg = false), 1500);
      }
    },

    nextFunc() {
      this.activeIndex++;
    },
    AmtSwicth() {
      switch (this.titleProduct) {
        case "Arnergy 5000":
          this.cacAmt = "";
          return;
        case "Arnergy 5000X":
          this.cacAmt = "4500000";
          return;
        case "Arnergy 10000":
          this.cacAmt = "7500000";
          return;
        default:
          return null;
      }
    },
    setComponentParams() {
      const _product = this.$store.state.onboardingPackageType;
      this.titleProduct = _product.name;
      this.amt = _product.amountOS;
      this.desc = _product.productDescription;
    }
  },
  async mounted() {
    // console.log(this.getCustomerProductOptions);
    this.fetchAll();
    this.AmtSwicth();

    // get active product == productType from store
    this.setComponentParams();

    this.tenures = this.productDetails.map(item => {
      return {
        id: item.id,
        name: item.contractTenure,
        caution: item.cautionFee,
        monthly: item.monthlyPayment,
        productID: item.productId
      };
    });
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

// .modal-mask {
//   margin-top: 30px!important;
//   position: fixed !important;
//   z-index: 98 !important;
//   top: 0 !important;
//   left: 0 !important;
//   width: 100% !important;
//   height: 100% !important;
//   background-color: rgba(0, 0, 0, 0.5) !important;
//   display: table !important;
//   transition: opacity 0.3s ease !important;
// }

// .modal-wrapper {
//   display: table-cell;
//   vertical-align: middle;
// }

.amt {
  font-size: 20px;
  color: $secondary-color;
  font-weight: bold;
}

.info-below {
  font-size: 16px;
  font-weight: 900;
}

.info-footer {
  float: left;
  margin-bottom: 3rem;
}

.modal-container {
  max-width: 500px !important;
  width: 100%;
  margin: 0px auto !important;
  padding: 20px 30px !important;
  background-color: #fff !important;
  // height: 90vh !important;
  // overflow-y: scroll !important;
  border-radius: 2px !important;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33) !important;
  transition: all 0.3s ease !important;
  font-family: Helvetica, Arial, sans-serif !important;
}

.modal-header {
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn {
    color: orangered;
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.modal-body {
  margin: 20px 0 !important;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.success-message {
  margin-top: 160px;
  margin-bottom: 140px;
}

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  color: $primary-color;
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/TestModal2.vue